import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';


@Component({
  selector: 'app-action-complaints',
  templateUrl: './action-complaints.component.html',
  styleUrls: ['./action-complaints.component.css']
})
export class ActionComplaintsComponent implements OnInit {
  complaintRefID;
  userInfo: any;

  public complaint:any = {};
  public complaintData:any = {};
  public employeeData:any = {};
  public complaintID:any = {};
  public actionMessage:any = {};
  public updatedBy:any = {};
  public name:any = {};
  public updatedAt:any={};
  public compStatus:number;
  public showComplaintLog: boolean = false;


  public page = 1;
  public complaintLog = [ ];
  public complaintDate=1633046400000;
  public enableTable:boolean = false;
  public enableComplaintCount: boolean = false;
  public employeeInfo : any ={};
  public noDataEnable: boolean = false;

  public actionFormEnable:boolean = false;
  public complaintForm:FormGroup;
  public tableData = [];

  public fieldOptions = {
    status:[
      {name:'Completed',value:3},
      {name:'In-Progress',value:2},
      {name:'Pending',value:1},
      {name:'Rejected',value:4}, ],
    };
  public finalCheck:boolean = false;
    
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,) { 
      // this.orgID = this.storage.get('userInfo').orgID;
      // this.route.paramMap.subscribe((params: any) => {
      //   this.complaintID = params.params.complaintID;  
      // });

    }

  ngOnInit(): void {
    this.complaintRefID = this.route.snapshot.paramMap.get('complaintRefID');
    console.log(this.complaintRefID)

    this.complaintFormLoad();
    this.getComplaintData();
  
  }
 
  getUserData() {
    this.api.GetCurUserOrg({}).then((res: any) => {
      if (res.status == 'success') {
        this.userInfo = res.data[0];

       
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }

  getComplaintData(params: any = { 
    complaintRefID:undefined,}
     ){
   
    const obj = { 
      complaintRefID: this.complaintRefID
    };
 
    this.showComplaintLog = false;
    this.api.transportManagerComplaintList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.complaintData = res.data[this.complaintRefID];
        this.employeeInfo = this.complaintData['employeeInfo'];
        this.complaint = this.complaintData['complaint'];
        this.complaintLog = this.complaintData['complaintLog'];
        this.showComplaintLog = true;
       
        if (this.complaintData){
          this.patchStatus(this.complaintData['status']);
        
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  };


 

  complaintFormLoad() {
    this.complaintForm = new FormGroup({
      compStatus: new FormControl('', [Validators.required]),
      actionMessage: new FormControl('', [Validators.required]),
    });
  }
  patchStatus(value){
    this.complaintForm.controls['compStatus'].patchValue(value);
  }
 
  public checkError = (controlName: string, errorName: string) => {
    return this.complaintForm.controls[controlName].hasError(errorName);
  }
  onSubmit(){
    this.finalCheck = true;
    console.log(this.complaintForm.value);
    if(this.complaintForm.valid){
      // console.log(this.complaintForm.value)
      let obj = {
        actionMessage: this.complaintForm.value.actionMessage,

        compStatus: +this.complaintForm.value.compStatus,
        complaintID: this.complaintData['complaint'].complaintID,
        complaintLogID:this.complaintData['complaintLog'].complaintLogID,
        complaintRefID: this.complaintRefID,
        orgID: this.complaintData['complaint'].orgID,
        
        updatedBy: "You",
        updatedAt: new Date().getTime(),
     
      };
      // console.log(obj);
      // let statusObj = {
      //   ...obj,
      //   updateBy:'Raja',
      //   updateDate:new Date().getTime(),
      // };
 
       this.api.transportManagerComplaintUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.complaintForm.reset();
          this.finalCheck = false;

         this.getComplaintData();
          this.swal.swalFunction(res.status, res.status, res.message, 2000);

          this.showComplaintLog = false;

          // this.complaintLog.push(obj);
          this.complaintLog = [obj].concat( this.complaintLog)
       
          setTimeout(()=>{
            this.showComplaintLog = true;
            
          });
          // this.router.navigate(['/organization/transport-manager/support-desk/complaint/view-complaint'])
  
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

}
